import React from 'react';

import * as Modules from './blocks/index.js';

/* ========================================================================= */
/* Constant(s) */
/* ========================================================================= */

const bleedYModules = [
    'AccordionBlock',
    'ContactLinksBlock',
    'KeyLinksBlock',
    'StampDutyCalculatorBlock',
    'ValuationLinksBlock',
    'OffMarketBannerBlock'
];

// modules without backgrounds,
// to compensate and hide bleed
const basicModules = [
    'FeaturedTaxonomyBlock',
    'SectionBlock'
];

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').ModuleDispatcher}
 */
const Dispatcher = ({
    classes   = null,
    module    = null,
    namespace = null,
    pageType  = null,
    propertyName = '',
    ...props
}) => {
    const additionalClasses =  bleedYModules.includes(module?.__typename) ? ' module--y-bleed' : basicModules.includes(module?.__typename) ? ' module--basic': '';

    if (pageType === 'brochure') {
        switch (module?.__typename) {
            case 'ImageBlock':
            case 'LargeImageBlock':
                return (
                    <div
                        className='print-page bg-white'>
                        <Modules.BrochureImageBlock {...module} />
                    </div>
                );
            case 'SectionBlock':
                return (
                    <Modules.BrochureSectionBlock
                        propertyName={propertyName}
                        {...module}/>
                );
            default:
                return null;
        }
    } else {
        switch (module?.__typename) {
            case 'RelatedPropertiesCarousel':
            case 'RelatedRentalPropertiesCarousel':
                const filteredItems = props.currentPage ? module.carouselItems.filter(item => item.id !== props.currentPage.id) : module.carouselItems;
                const items = filteredItems.slice(0,6);

                if (!items.length) {
                    return null;
                }
                else {
                    const Component = Modules[module?.__typename];
                    if (Component) {
                        return (
                            <div
                                className={`module${classes ?? ''}${additionalClasses}`}>
                                <Component
                                    namespace={namespace}
                                    {...module}
                                    {...props}/>
                            </div>
                        );
                    }
                    return null;
                }
            default:
                const Component = Modules[module?.__typename];
                if (Component) {
                    return (
                        <div
                            className={`module${classes ?? ''}${additionalClasses}`}>
                            <Component
                                namespace={namespace}
                                {...module}
                                {...props}/>
                        </div>
                    );
                }
                return null;
        }
    }
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Dispatcher.displayName = 'ModuleDispatcher';

export default Dispatcher;
